import React from 'react';
import SessionList from '../../components/SessionList';

const ReportsIndex: React.FC = () => {
  return <SessionList />;
};

export default ReportsIndex;
